export default "__VITE_ASSET__hczBd9Gp__"